import { ReactElement, useEffect } from "react";

import { error } from "@pnotify/core";
import "@pnotify/core/dist/PNotify.css";
import "@pnotify/core/dist/BrightTheme.css";
import dayjs from "dayjs";

import { useErrorContext } from "hooks/error";

interface GlobalErrorScreenProps {
  children: ReactElement;
}

export function GlobalErrorScreen({
  children,
}: GlobalErrorScreenProps): ReactElement | null {
  const { state } = useErrorContext();

  useEffect(() => {
    if (!state) return;
    const text = `
Status Code: ${state.status}
Message: ${state.responseBody}
Timestamp: ${dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss")}
    `;
    error({
      title: "エラーが発生しました",
      text,
      mode: "light",
      hide: false,
      sticker: false,
    });
  }, [state]);

  return children;
}
